import type { Role } from '@customTypes/types';
import React from 'react';

import { useProfileStore } from '@/shared/store/profileStore';

import { useCreateOrGetConversation } from '../hooks';

export const CreateConversationButton = ({
  recipientProfileId,
  recipientProfileRole,
  children
}: {
  recipientProfileId: string;
  recipientProfileRole: Role;
  children: React.ReactElement;
}) => {
  const { profile, currentSessionId } = useProfileStore();

  const { createConversation } = useCreateOrGetConversation({
    senderProfileId: currentSessionId?.toString()!,
    recipientProfileRole,
    senderProfileRole: profile?.role!,
    recipientProfileId
  });

  return React.cloneElement(children, {
    onClick: createConversation
  });
};
